import { NotificationState, TypeKeys } from "./types";
import { ActionTypes } from './actions';

const initialState : NotificationState = {
    notificationText: null,
    notificationSubText: null,
}

export const notificationReducer = (
    state: NotificationState = initialState,
    action: ActionTypes
) => {
    switch (action.type) {
        case TypeKeys.SHOW_NOTIFICATION:
            return {
                notificationText: action.text,
                notificationSubText: action.subText,
            }
        case TypeKeys.CLEAR_NOTIFICATION:
            return {
                notificationText: null,
                notificationSubText: null,
            }
        default:
            return {
                ...state
            }
    }
}

